import { Card, Input, Skeleton } from 'antd';
import useAccountConfirmation, { ConfirmationResult, ConfirmationType } from "hooks/useAccountConfirmation";
import { FC, useCallback, useEffect, useState } from "react";

interface ConfirmationCodeProps {
    required: boolean;
    validRequest: boolean;
    onChange: (code: string) => void;
}

const confirmationCopy = (type?: ConfirmationType) => {
    switch (type) {
        case ConfirmationType.Email:
            return {
                title: "Confirmation Code Required",
                message: "For added security, a confirmation code has been emailed to you. Please enter the code to submit your request.",
                placeholder: "Email Code"
            };

        case ConfirmationType.MFA:
            return {
                title: "Authenticator Code Required",
                message: "For added security, please enter a dcsports87 code from your authenticator app.",
                placeholder: "6-Digit Authenticator Code"
            };

        default:
            return {};
    }
};

const ConfirmationCode: FC<ConfirmationCodeProps> = ({ required, validRequest, onChange }) => {
    const { requestConfirmation, isLoading } = useAccountConfirmation();
    const [details, setDetails] = useState<ConfirmationResult>();

    const makeRequest = useCallback(async () => {
        var result = await requestConfirmation();
        setDetails(result);
    }, [requestConfirmation, setDetails]);

    useEffect(() => {
        if (required) {
            makeRequest();
        }
    }, [makeRequest, required]);

    if (!required || !validRequest) {
        return null;
    }

    if (isLoading) {
        return <Skeleton active />
    }

    const { title, message, placeholder } = confirmationCopy(details?.method);

    return <div style={{ margin: '5px 0px' }}>
        <Card title={title} bordered={false} headStyle={{ textAlign: 'center' }}>
            <p>{message}</p>
        </Card>
        <Input
            size='large'
            style={{ marginTop: '10px', textTransform: 'uppercase' }}
            placeholder={placeholder}
            onChange={e => onChange(e.currentTarget.value.trim().toUpperCase())}
        />
    </div>
};

export default ConfirmationCode;